function initTestimonialSlider() {
  const sliderEl = document.querySelector(".testimonial-swiper");
  if (!sliderEl) return;

  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  const enableAutoplay = sliderEl.dataset.autoplay === "true";

  new Swiper(sliderEl, {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 20,
    loop: true,

    autoplay: enableAutoplay
      ? {
          delay: 3000,
          disableOnInteraction: false,
        }
      : false,

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 38,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 48,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 48,
        centeredSlides: false,
      },
    },
  });
}

// Run on normal page load
document.addEventListener("DOMContentLoaded", initTestimonialSlider);

// Run again in Shopify editor
document.addEventListener("shopify:section:load", initTestimonialSlider);
document.addEventListener("shopify:block:select", initTestimonialSlider);
document.addEventListener("shopify:block:deselect", initTestimonialSlider);